import { render, staticRenderFns } from "./DismantleList.vue?vue&type=template&id=6f789bdb&"
import script from "./DismantleList.vue?vue&type=script&lang=js&"
export * from "./DismantleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports